import { createContext } from "react";

export const ProgramDetailContext = createContext();
